// extracted by mini-css-extract-plugin
module.exports = {"bg":"e_eq","border":"e_fq"};